import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "honex-cookie-consent-v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Default: opt-out of tracking until user decides
      try {
        window.posthog && window.posthog.opt_out_capturing && window.posthog.opt_out_capturing();
      } catch (_) {
        // ignore
      }
      // Small delay so the banner doesn't flash before paint
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    } else if (stored === "accepted") {
      try {
        window.posthog && window.posthog.opt_in_capturing && window.posthog.opt_in_capturing();
      } catch (_) {
        // ignore
      }
    } else {
      try {
        window.posthog && window.posthog.opt_out_capturing && window.posthog.opt_out_capturing();
      } catch (_) {
        // ignore
      }
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    try {
      window.posthog && window.posthog.opt_in_capturing && window.posthog.opt_in_capturing();
    } catch (_) {
      // ignore
    }
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, "declined");
    try {
      window.posthog && window.posthog.opt_out_capturing && window.posthog.opt_out_capturing();
    } catch (_) {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] bg-zinc-950 text-white border border-zinc-800 shadow-2xl p-5 md:p-6"
    >
      <div className="flex items-start gap-3 mb-4">
        <span className="w-2 h-2 bg-red-500 mt-1.5 flex-shrink-0" />
        <h3 className="font-display text-sm md:text-base font-bold uppercase tracking-widest text-white">
          Cookies & Datenschutz
        </h3>
      </div>
      <p className="text-xs md:text-sm text-zinc-300 leading-relaxed font-light">
        Wir verwenden nur technisch notwendige Cookies und – mit Ihrer Einwilligung –
        einen anonymisierten Analyse-Dienst, damit wir diese Website verbessern können.
        Details in unserer{" "}
        <Link to="/datenschutz" className="underline hover:text-red-500">
          Datenschutzerklärung
        </Link>
        .
      </p>
      <div className="mt-5 grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={decline}
          data-testid="cookie-decline"
          className="border border-zinc-700 text-zinc-200 hover:border-white hover:text-white px-4 py-3 text-xs font-bold uppercase tracking-widest transition-colors"
        >
          Ablehnen
        </button>
        <button
          type="button"
          onClick={accept}
          data-testid="cookie-accept"
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-3 text-xs font-bold uppercase tracking-widest transition-colors"
        >
          Akzeptieren
        </button>
      </div>
    </div>
  );
}
